import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found">
      <div className="not-found__container">
        <div className="not-found__content">
          <h1 className="not-found__title">404</h1>
          <h2 className="not-found__subtitle">Page Not Found</h2>
          <p className="not-found__description">
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          
          <div className="not-found__actions">
            <button 
              className="not-found__button not-found__button--primary"
              onClick={handleGoHome}
            >
              Go Home
            </button>
            <button 
              className="not-found__button not-found__button--secondary"
              onClick={handleGoBack}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
